import { CertificateExtension } from '../../../common/certificates/models/valueObjects/CertificateExtension';
import { CertificateValidity } from '../../../common/certificates/models/valueObjects/CertificateValidity';
import { CertificateValue } from '../../../common/certificates/models/valueObjects/CertificateValue';
import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';
import { SignatureAlgorithm } from '../../../common/certificates/models/valueObjects/SignatureAlgorithm';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportCertificateDetail } from '../models/ReportCertificateDetail';

export class ReportCertificateDetailMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any, reportVenafiGuidsUpdatedAt: string | null) {
    const publicKey = new PublicKey(this.gqlIdEncoder.decode(data.publicKey.id), data.publicKey.shortDescription, data.publicKey.hasPrivateKey);
    const validity = new CertificateValidity(
      data.notBefore ? DateUtils.toMoment(data.notBefore) : null,
      data.notAfter ? DateUtils.toMoment(data.notAfter) : null
    );
    const extensions = data.extensions?.map((ext: any) => new CertificateExtension(ext.name ?? '', ext.value ?? '', ext.critical)) || null;
    const signatureAlgorithm = data.signatureAlgorithm
      ? new SignatureAlgorithm(data.signatureAlgorithm.digest, data.signatureAlgorithm.algorithm, data.signatureAlgorithm.rsaPadding)
      : null;
    const value = new CertificateValue(
      data.version ?? '',
      data.serialNumber,
      data.subject,
      data.issuer,
      validity,
      extensions,
      signatureAlgorithm,
      data.signature
    );

    const organizationCertificateId = data.organizationCertificate?.id ? this.gqlIdEncoder.decode(data.organizationCertificate.id) : null;
    return new ReportCertificateDetail(
      this.gqlIdEncoder.decode(data.id),
      publicKey,
      data.isSelfSigned,
      data.isCa,
      value,
      data.encoded,
      organizationCertificateId,
      data.fingerprint,
      data.venafiGuid,
      reportVenafiGuidsUpdatedAt ? DateUtils.toMoment(reportVenafiGuidsUpdatedAt) : null
    );
  }
}
